export const FORMAT_DATE_UTC = "yyyy-MM-dd'T'HH:mm:ss'Z'";
export const FORMAT_DATE = 'dd-MM-yyyy';
export const DEFAULT_DATE_FORMAT = 'dd/MM/yyyy';
export const FORMAT_TIME = 'HH:mm:ss';
export const FORMAT_DATE_TIME = 'dd-MM-yyyy HH:mm:ss';
export const FORMAT_DATE_TIME_ZONE = "yyyy-MM-dd'T'HH:mm:ssXXX";
export const FORMAT_DATE_LLLL = 'EEE d MMM, yyyy HH:mm a';
